export default (ms: number): Promise<unknown> =>
  new Promise((resolve) => setTimeout(resolve, ms));
